var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cell", on: { click: _vm.onClick } }, [
    _c("div", { staticClass: "cell-hd" }, [_vm._t("icon")], 2),
    _c(
      "div",
      { staticClass: "cell-bd" },
      [
        _vm._t("title", function() {
          return [_vm._v(_vm._s(_vm.title))]
        })
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "cell-ft", class: _vm.valueClass },
      [
        _vm._t("value", function() {
          return [_vm._v(_vm._s(_vm.value))]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bc502e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bc502e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/cell/index.vue
// module id = xH+2
// module chunks = 1 2 3 6 8 15 16 18 19 20 21 22 25 37